export const PROSE_REGEX_MARKDOWN_BOLD = /\*{2}(.*?)\*{2}/g;
